import React from 'react';
import './Asidebar.css';
import { MenuAsidebar } from '../MenuAsidebar/MenuAsidebar';
import { Link } from 'react-router-dom';
 
export const Asidebar = ({initData}) => {
  const { nombre_completo,usuario } = initData;
  return (
    <div className="ws-asidebar-left text-center">
      <div className="ws-asidebar-title p-3">
        <h2>Menu</h2>
        <i className="bi bi-chevron-double-left"></i>
      </div>
      <div className="ws-asidebar-body">
        <div className="ws-menu-bar">
          <div className="container mb-3 mt-2">
            <div className="row">
              <div className="col-5 text-start">
                <img className="ws-img-perfil" src="https://tarjeta.id/imports/gXuLyUj0kR-yry4M0XNjm-zDlRPoDd7c-3W2yU0f/imgs/IMG-PERFIL-ORIGINAL.png?v=63056e197c7a6" alt="img-perfil" />
              </div>
              <div className="col-7 text-start ps-1">
                <p style={{fontSize:'.85rem'}} className="mb-1">{ nombre_completo }</p>
                <p style={{fontSize:'.85rem',color:'#949494'}} className="mb-1">Plan Premium</p>
              </div>
            </div>
          </div>
    
          <div className="ps-3 pe-3 mb-3 mt-4">
            <Link to="/home" className="ws-btn ws-btn-primary ws-w-100 ws-d-f ws-j-c-b">
              <span>
                <i className="bi bi-house-door"></i> Principal
              </span>
              <i className="bi bi-chevron-right"></i> 
            </Link>
          </div>
          
          <p className="mb-0 p-3 pt-1 pb-1 ws-asidebar-category-title">Modulos</p>
  
          <MenuAsidebar />
     
        </div>
      </div>
    </div>

  )
}
